<template>
    <div class="orders-dialog">
        <p class="dialog-order-item" v-for="orderId of orders" :key="orderId">
            <a :href="orderDetailUrlPrefix+orderId" target="_blank">{{orderId}}</a>
        </p>
    </div>
</template>
<script>
    import { otpHost } from "config/env.conf";
    export default {
      props: {
        hasMore: {
          required: true
        },
        orders: {
          required: true,
          type: Array
        }
      },
      data: function() {
        return {
          orderDetailUrlPrefix: `${otpHost}#/jiujing/gtyOrder/detail-order?orderId=`
        };
      }
    };
</script>
<style lang="scss">
.orders-dialog {
  margin: 10px 0 -30px 0;
  .dialog-order-item {
    text-align: center;
    font-size: 16px;
    line-height: 1.6em;
  }
}
</style>



// WEBPACK FOOTER //
// orders.vue?50fc7a2a